import React, { useEffect } from 'react';

import Descriptions from '../styled/Descriptions';
import Host from '../styled/Host';
import Paragraph1 from '../styled/Paragraph1';
import Wrapper from '../styled/Wrapper';

const WindowTooSmall = () => {
  useEffect(() => {
    const shouldRemove = !document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      if (shouldRemove) document.body.style.overflow = '';
    };
  }, []);

  return (
    <Host>
      <Wrapper>
        <Descriptions>
          <Paragraph1>Window Too Small</Paragraph1>
        </Descriptions>
      </Wrapper>
    </Host>
  );
};

export default WindowTooSmall;
